import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImageModule, LinkModule } from '@com-delta-idp/mnx-ui-kit';
import { RelatedLinksComponent } from './related-links.component';

@NgModule({
  declarations: [RelatedLinksComponent],
  imports: [CommonModule, ImageModule, LinkModule],
  exports: [RelatedLinksComponent]
})
export class RelatedLinksModule {}
